import React, { useRef } from 'react'

const FileDropZone = ({ dragActive, onDrag, onDrop, onFileSelect }) => {
  const fileInputRef = useRef(null)

  const handleFileInput = (e) => {
    if (e.target.files && e.target.files[0]) {
      onFileSelect(e.target.files)
    }
  }

  return (
    <div
      className={`border-2 border-dashed rounded-xl p-8 text-center transition-all duration-300 ${
        dragActive
          ? 'border-purple-400 bg-purple-500/10'
          : 'border-white/30 hover:border-white/50 bg-white/5'
      }`}
      onDragEnter={onDrag}
      onDragLeave={onDrag}
      onDragOver={onDrag}
      onDrop={onDrop}
    >
      <div className="space-y-4">
        <UploadIcon />
        <DropZoneContent onSelectFiles={() => fileInputRef.current?.click()} />
      </div>

      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*,video/*"
        onChange={handleFileInput}
        className="hidden"
      />
    </div>
  )
}

const UploadIcon = () => (
  <div className="text-white/70">
    <svg className="w-12 h-12 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
    </svg>
  </div>
)

const DropZoneContent = ({ onSelectFiles }) => (
  <div>
    <p className="text-white text-lg font-medium mb-2">
      Drop your photos and videos here
    </p>
    <p className="text-gray-300 text-sm mb-4">
      or click to browse files
    </p>
    <button
      type="button"
      onClick={onSelectFiles}
      className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold py-2 px-6 rounded-xl transition-all duration-300"
    >
      Select Files
    </button>
    <p className="text-gray-400 text-xs mt-2">
      Images and videos up to 50MB each
    </p>
  </div>
)

export default FileDropZone